// Curated, pedagogical learning sequence for the "Recommended Next" strip.
// Each entry: { to (route), labelKey (translation key, reuses nav_* labels), Icon }.
// Icons are imported statically (no dynamic JSX tag) to keep the linter happy.
import {
  Camera,
  GridFour,
  ClockCounterClockwise,
  Aperture,
  Lightbulb,
  Crosshair,
  Gauge,
  ChartBar,
  PlusMinus,
  Thermometer,
  Square,
  Ruler,
  ArrowsHorizontal,
  Target,
  CircleDashed,
  Sun,
  PersonSimple,
  FilmStrip,
  ClipboardText,
  Buildings,
  Printer,
  Monitor,
  Plug,
  DeviceMobile,
  Wrench,
  FileText,
  TextAa,
  Cards,
  BookOpen,
  CircleHalf,
} from "@phosphor-icons/react";

export const LEARNING_PATH = [
  { to: "/anatomy", labelKey: "nav_anatomy", Icon: Camera },
  { to: "/bayer-filter", labelKey: "nav_bayer", Icon: GridFour },
  { to: "/camera-history", labelKey: "nav_camera_history", Icon: ClockCounterClockwise },
  { to: "/mode-dial", labelKey: "nav_mode_dial", Icon: Aperture },
  { to: "/lighting-basics", labelKey: "nav_lighting_basics", Icon: Lightbulb },
  { to: "/metering", labelKey: "nav_metering", Icon: Crosshair },
  { to: "/light-meter", labelKey: "nav_light_meter", Icon: Gauge },
  { to: "/histogram", labelKey: "nav_histogram", Icon: ChartBar },
  { to: "/exposure-compensation", labelKey: "nav_exposure", Icon: PlusMinus },
  { to: "/white-balance", labelKey: "nav_whitebalance", Icon: Thermometer },
  { to: "/gray-card", labelKey: "nav_graycard", Icon: Square },
  { to: "/crop-factor", labelKey: "nav_cropfactor", Icon: Ruler },
  { to: "/lens-compression", labelKey: "nav_compression", Icon: ArrowsHorizontal },
  { to: "/advanced-focus", labelKey: "nav_focus", Icon: Target },
  { to: "/filters", labelKey: "nav_filters", Icon: CircleDashed },
  { to: "/golden-hour", labelKey: "nav_golden_hour", Icon: Sun },
  { to: "/lighting", labelKey: "nav_lighting", Icon: Lightbulb },
  { to: "/poses", labelKey: "nav_poses", Icon: PersonSimple },
  { to: "/shots", labelKey: "nav_shots", Icon: FilmStrip },
  { to: "/studio", labelKey: "nav_studio", Icon: Buildings },
  { to: "/printing", labelKey: "nav_printing", Icon: Printer },
  { to: "/calibration", labelKey: "nav_calibration", Icon: Monitor },
  { to: "/tether", labelKey: "nav_tether", Icon: Plug },
  { to: "/smartphone-photography", labelKey: "nav_smartphone", Icon: DeviceMobile },
  { to: "/film-photography", labelKey: "nav_film", Icon: FilmStrip },
  { to: "/black-white", labelKey: "nav_bw", Icon: CircleHalf },
  { to: "/prep-checklist", labelKey: "nav_checklist", Icon: ClipboardText },
  { to: "/maintenance", labelKey: "nav_maintenance", Icon: Wrench },
  { to: "/forms", labelKey: "nav_forms", Icon: FileText },
  { to: "/glossary", labelKey: "nav_glossary", Icon: TextAa },
  { to: "/task-cards", labelKey: "nav_task_cards", Icon: Cards },
  { to: "/guide", labelKey: "nav_guide", Icon: BookOpen },
];

// All routes that are part of the learning path (used to gate pageview tracking
// and the Recommended Next strip).
export const LESSON_PATHS = LEARNING_PATH.map((l) => l.to);

// Returns the next `count` lessons after the given path (wraps to the start
// so the very last lesson still suggests something). Returns [] for non-lessons.
export function getRecommendedNext(path, count = 2) {
  const norm = (path || "").replace(/\/+$/, "") || "/";
  const idx = LEARNING_PATH.findIndex((l) => l.to === norm);
  if (idx === -1) return [];
  const out = [];
  for (let i = 1; i <= count; i++) {
    out.push(LEARNING_PATH[(idx + i) % LEARNING_PATH.length]);
  }
  return out;
}
